import axios from 'axios';
import {
    SET_GET_INSTANCES_REQUEST,
    SET_GET_INSTANCES_SUCCESS,
    SET_GET_INSTANCES_ERROR,
    SET_SELECT_INSTANCE,

    SET_GET_AVAILABLE_INSTANCES_REQUEST,
    SET_GET_AVAILABLE_INSTANCES_SUCCESS,
    SET_GET_AVAILABLE_INSTANCES_ERROR,

    SET_ALL_AVAILABLE_DOCKERS_REQUEST,
    SET_ALL_AVAILABLE_DOCKERS_SUCCESS,
    SET_ALL_AVAILABLE_DOCKERS_ERROR,

 } from './../../../constants/closeLoop/apmDashboard/instancesConstants';


export const getInstances = () => (dispatch) => {
    try {
        dispatch({type: SET_GET_INSTANCES_REQUEST});
        const url = "/get/running/instances";
        axios.get(url).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_GET_INSTANCES_SUCCESS, payload: response.data});
            } else {
                dispatch({type: SET_GET_INSTANCES_ERROR, payload: response.message});
            }
        }).catch((error) => {
            console.error(error);
            dispatch({
                type: SET_GET_INSTANCES_ERROR,
                payload: error.response.data.message
            });
        })
    } catch(error) {
        console.error(error);
        dispatch({type: SET_GET_INSTANCES_ERROR, payload: error.message});
    }
}

export const setSelectedInstance = (instance) => (dispatch) => {
    dispatch({type: SET_SELECT_INSTANCE, payload: instance});
};


export const formatAvailableInstances = (region) => (dispatch) => {
    dispatch({type: SET_GET_AVAILABLE_INSTANCES_REQUEST});
    const url = `/close_loop/region/running/instances?region=${region}`;
    try {
        axios.get(url).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_GET_AVAILABLE_INSTANCES_SUCCESS, payload: response.data});
            } else {
                dispatch({type: SET_GET_AVAILABLE_INSTANCES_ERROR, payload: response.message});
            }
        }).catch((error) => {
            console.error(error);
            dispatch({
                type: SET_GET_AVAILABLE_INSTANCES_ERROR,
                payload: error.response.data.message
            });
        })
    } catch(error) {
        console.error(error);
        dispatch({type: SET_GET_AVAILABLE_INSTANCES_ERROR, payload: error.message});
    }
};


export const getAllAvailableDockers = (payload) => (dispatch) => {
    dispatch({type: SET_ALL_AVAILABLE_DOCKERS_REQUEST});
    const url = `/get/running/containers/instance?instance_id=${payload}`;
    try {
        axios.get(url).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_ALL_AVAILABLE_DOCKERS_SUCCESS, payload: response.data});
            } else {
                dispatch({type: SET_ALL_AVAILABLE_DOCKERS_ERROR, payload: "Unable to process this request!"});
            }
        }).catch((error) => {
            console.log(error);
            dispatch({type: SET_ALL_AVAILABLE_DOCKERS_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.error(error);
        dispatch({type: SET_ALL_AVAILABLE_DOCKERS_ERROR, payload: error.message});
    }
};
